import { useEffect } from "react";

// Exposes a real, honest client-side tool to AI agents via the WebMCP API.
// Registers only when the browser/agent actually provides modelContext,
// so it is a no-op in normal browsers.
const SUPPEV_INFO =
  "Suppev is an educational platform that shows real scientific evidence (live PubMed research) " +
  "and anti-doping (WADA) reference status for dietary supplements. Features: AI supplement-label " +
  "scanner (evidence score, goal fit, clean-label check, estimated organ load and possible interactions), " +
  "an ingredient library, live PubMed search summarized neutrally, a personal stack builder, and a members " +
  "community. Free plan: 5 label scans per month. Premium: $9.99/month or $59.99/year, unlocking full PubMed " +
  "evidence and evidence by health condition. The Superathlete Formula is included only with the annual ($59.99/year) plan. Cancel anytime from the Premium page. " +
  "Suppev is educational only — not medical advice, not FDA-approved.";

export const WebMCP = () => {
  useEffect(() => {
    const mc =
      (typeof navigator !== "undefined" && navigator.modelContext) ||
      (typeof document !== "undefined" && document.modelContext);
    if (!mc || typeof mc.registerTool !== "function") return;

    const controller = new AbortController();
    try {
      mc.registerTool(
        {
          name: "suppev_about",
          description:
            "Get an overview of Suppev: what the app does, its features, free vs Premium plans, pricing, and how to cancel.",
          inputSchema: { type: "object", properties: {}, additionalProperties: false },
          execute: async () => ({ content: [{ type: "text", text: SUPPEV_INFO }] }),
        },
        { signal: controller.signal }
      );
    } catch (e) {
      /* WebMCP not available or registration rejected — safe to ignore */
    }
    return () => controller.abort();
  }, []);

  return null;
};

export default WebMCP;
